import { LOCALE_TO_SUBDOMAIN_MAP } from '@fiverr-private/localization';

const DOMAIN_NAME = 'fiverr.com';
const DEFAULT_SUBDOMAIN = 'www';

/**
 * Constructs a full URL from a given subdomain.
 * @param params
 * @param params.localeSubdomain
 * @param params.subdomain
 * @param params.url
 */
export const constructFiverrURLFromSubdomain = ({
    localeSubdomain,
    subdomain,
    url,
}: {
    localeSubdomain: string;
    subdomain: string;
    url: string;
}): string => {
    const { protocol, pathname } = new URL(url);

    if (localeSubdomain === DEFAULT_SUBDOMAIN) {
        return `${protocol}//${subdomain || DEFAULT_SUBDOMAIN}.${DOMAIN_NAME}${pathname}`;
    }

    const host = [localeSubdomain, subdomain, DOMAIN_NAME].filter(Boolean).join('.');

    return `${protocol}//${host}${pathname}`;
};

export const getSubdomain = (url: string): string => {
    const { hostname } = new URL(url);
    const excludedSubdomainHostParts = [...DOMAIN_NAME.split('.'), ...Object.values(LOCALE_TO_SUBDOMAIN_MAP)];

    return hostname
        .split('.')
        .filter((subdomainPart) => !excludedSubdomainHostParts.includes(subdomainPart))
        .join('.');
};

/** Canonical (www) form of a Fiverr URL: https://fr.fiverr.com/username -> https://www.fiverr.com/username */
export const getCanonicalUrl = (url: string): string =>
    constructFiverrURLFromSubdomain({
        localeSubdomain: DEFAULT_SUBDOMAIN,
        subdomain: getSubdomain(url),
        url,
    });
